import { render, staticRenderFns } from "./ReturnInvestment.vue?vue&type=template&id=45ea33d5"
import script from "./ReturnInvestment.vue?vue&type=script&lang=js"
export * from "./ReturnInvestment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports